import { useLocale } from '../i18n/LocaleContext';
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const FAQsPage = () => {
  const { t } = useLocale();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.001')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.002')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.003')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.004')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.005')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.006')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.007')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.008')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.009')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.010')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.011')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.012')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.013')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.014')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.015')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.016')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.017')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.018')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.019')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.020')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.021')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.022')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.023')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.024')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.025')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.026')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <FAQItem>
        <FAQQuestion>{' '}{t('faqs.027')}{' '}</FAQQuestion>
        <FAQAnswer>
          <p>{' '}{t('faqs.028')}{' '}</p>
        </FAQAnswer>
      </FAQItem>

      <LastUpdated>{' '}{t('faqs.029')}{' '}</LastUpdated>
    </motion.div>
  );
};

const FAQItem = styled.div`
  margin-bottom: 25px;
`;

const FAQQuestion = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--primary-dark);
  margin-bottom: 10px;
`;

const FAQAnswer = styled.div`
  color: var(--dark-gray);
  line-height: 1.6;

  p {
    margin-bottom: 15px;
  }
`;

const LastUpdated = styled.p`
  font-style: italic;
  color: var(--secondary);
  text-align: center;
  margin-top: 50px;
  font-size: 0.9rem;
`;

export default FAQsPage;
